import { UserStateTypes } from "../../utils/constants";
import { OfficePatientFilterType } from "./OfficePatientFilterSelect";

export const getParamsFromPatientFilter = (filter: OfficePatientFilterType) => {
  switch (filter) {
    case OfficePatientFilterType.Subscribed:
      return {
        userState: UserStateTypes.Active,
        hasAnnualPlan: true,
      }
    case OfficePatientFilterType.All:
      return {
        userState: UserStateTypes.All,
        hasAnnualPlan: false,
      }
    case OfficePatientFilterType.Active:
      return {
        userState: UserStateTypes.Active,
        hasAnnualPlan: false,
      }
    case OfficePatientFilterType.Invited:
      return {
        userState: UserStateTypes.Invited,
        hasAnnualPlan: false,
      }
    case OfficePatientFilterType.Disabled:
      return {
        userState: UserStateTypes.Disabled,
        hasAnnualPlan: false,
      }
  }
}
